var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldWrapper',{attrs:{"label":_vm.label,"state":_vm.state,"is-required":_vm.isRequired,"class-label":_vm.classLabel}},[_c('InputDate',{attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"type":"datetime","format":"DD/MM/YYYY HH:mm"},model:{value:(_vm.timestamp),callback:function ($$v) {_vm.timestamp=$$v},expression:"timestamp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }